import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('UserProfilePage.feedback')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_back_button, {
                        mode: "ios",
                        "default-href": "/profile"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('FeedbackPage.contactInfo')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('FeedbackPage.nickname')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        placeholder: $setup.t('FeedbackPage.enterNickname'),
                        modelValue: $setup.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.name) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('FeedbackPage.email')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        placeholder: $setup.t('FeedbackPage.enterEmail'),
                        type: "email",
                        modelValue: $setup.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.email) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('FeedbackPage.feedback')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('FeedbackPage.feedback')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_textarea, {
                        placeholder: $setup.t('FeedbackPage.enterFeedback'),
                        modelValue: $setup.feedback,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.feedback) = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('photo')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        type: "file",
                        accept: "image/*",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.onImageFileChange($event)))
                      }),
                      ($setup.photo)
                        ? (_openBlock(), _createBlock(_component_ion_buttons, {
                            key: 0,
                            slot: "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clearUploadedImage()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  ($setup.photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $setup.photo,
                        style: {"display":"block","margin":"auto"}
                      }, null, 8, _hoisted_1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                class: "submit-btn",
                expand: "block",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.submitFeedback()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('submit')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}